import client from '@/api/client'

export async function getGlobalSearchResult(keyword: string) {
    return await client.get(`/global-search/${keyword}`)
}

export async function addVisitHistory(item: string) {
    return await client.post(`/global-search/history`, {item})
}
